import { ArrowForward, Restaurant, ShoppingCart } from '@mui/icons-material';
import React from 'react';
import { useConfig } from '../../../../context/ConfigContext';
import { Category } from '../../../../interfaces/Catalogue';
import './CategoryCard.scss';
import ImageLazyLoader from '../../../common/ImageLazyLoader';

interface CategoryCardProps {
  category: Category;
  onPress: (category: Category) => void;
  itemsPerRow?: 1 | 2 | 3 | 4;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  onPress,
  itemsPerRow = 2,
}) => {
  const isPhone = window.innerWidth <= 768;
  const { config } = useConfig();
  const isNew = false
  const isPopular = false

  const cardClasses = [
    'cc-card-wrapper',
    `cc-items-per-row-${itemsPerRow}`
  ].join(' ');

  const getBadgeText = () => {
    if (isPopular) return 'Popular';
    if (isNew) return 'New';
    return null;
  };

  return (
    <div
      className={cardClasses}
      onClick={() => onPress(category)}
    >
      <ImageLazyLoader
        src={category.imageUrl || config?.appLogoImage || '/placeholder-image.png'}
        alt={category.designation}
        effect="blur"
        className="cc-card-image"
      />

      {/* Default overlay - visible when not hovering */}
      {!isPhone && (
        <div className="cc-card-overlay">
          <div className="cc-name-overlay">{category.designation}</div>
        </div>
      )}


      {!isPhone && (
        <div className="cc-hover-content">
          {/* Hover content */}
          <div className="cc-info-section">
            <div className="cc-name-text">{category.designation}</div>
            {(isNew || isPopular) && (
              <div className="cc-status-badge">{getBadgeText()}</div>
            )}
          </div>

          <button className="cc-cta-button">
            <Restaurant className="cc-cta-icon" />
            <span className="cc-cta-text">Découvrir le Menu</span>
            <ArrowForward className="cc-cta-icon" />
          </button>
        </div>
      )}

      {isPhone && (
        <div className="cc-mobile-content">
          <div className="cc-mobile-info-section">
            <ShoppingCart className="cc-cta-icon" />
            <div className="cc-name-text">Commander</div>
          </div>
        </div>
      )}
    </div>
  );
};

